import firebase from 'firebase/app';
import 'firebase/firestore';

const firebaseConfig = {
    apiKey: 'AIzaSyA52H3XghhBzYcAVpECerUZZN_hk7n_eXA',
    authDomain: 'survey-246215.firebaseapp.com',
    databaseURL: 'https://survey-246215.firebaseio.com',
    projectId: 'survey-246215',
    storageBucket: 'survey-246215.appspot.com',
    messagingSenderId: '438571095976',
    appId: '1:438571095976:web:6d93e97e4f27a2a6cdaf9d',
};

firebase.initializeApp(firebaseConfig);

export const db = firebase.firestore();
